import type { Media } from '../../types/props'

export interface VideoFeatureProps {
  data: {
    /** 主标题 */
    title: string
    /** 副标题/描述 */
    subtitle?: string
    /** 桌面端视频 URL */
    video: Media
    /** 桌面端视频封面图 */
    poster?: Media
    /** 移动端视频 URL */
    mobvideo?: Media
    /** 移动端视频封面图 */
    mobPoster?: Media
  }
  /** 自定义类名 */
  className?: string
}
